export default [
  {
    title: "Dashboard",
    customIcon: "CustomSVG",
    children: [
      // {
      //   title: "Overall",
      //   route: "custom-module",
      //   path: "/custom-module/nt-dashboard-all",
      // },
      {
        title: "Management",
        route: "custom-module",
        path: "/custom-module/dashboardManagement",
      },
      // {
      //   title: "Operation",
      //   route: "custom-module",
      //   path: "/custom-module/nt-dashboard-operation",
      // },
      // {
      //   title: "Point n Billing",
      //   route: "custom-module",
      //   path: "/custom-module/nt-dashboard-point-and-billing",
      // },
      // {
      //   title: "Special Campaign",
      //   route: "custom-module",
      //   path: "/custom-module/nt-dashboard-special-campaign",
      // },
      // {
      //   title: "Monthly Campaign",
      //   route: "custom-module",
      //   path: "/custom-module/nt-dashboard-monthly-campaign",
      // },
    ],
  },
];
